import {
    Dialog,
    FormControl,
    IconButton,
    List,
    MenuItem,
    Select,
    Slide,
    Toolbar,
} from "@mui/material";
import { ShareIos } from "iconoir-react";
import { inject, observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { getNameInCapitalize } from "../../utils/common";
import CloseIcon from "../image/CloseIcon";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});
const SelecteUserDialog = ({ open, handleClose, companyStore }) => {
    const { getCompanyList, companyList } = companyStore;
    const [companyCode, setCompanyCode] = useState();
    useEffect(() => {
        (async () => {
            await Promise.all([getCompanyList()]);
            setCompanyCode(companyList[0].code);
        })();
        return () => {};
    }, [JSON.stringify(companyList)]);
    const handleChangeCompany = (e) => {
        setCompanyCode(e.target.value);
    };
    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
        >
            <div className="px-5 mt-[14px] ">
                <div className="flex items-center gap-5">
                    <span onClick={handleClose}>
                        <CloseIcon />
                    </span>
                    <span className="large-text">Chọn người/ban</span>
                </div>
                <List className="mb-[70px] min-h-screen mt-5">
                    <div className="small-text mb-[6px]">Công ty</div>
                    <FormControl fullWidth>
                        <Select
                            sx={{
                                fontSize: "14px",
                                fontWeight: 400,
                                "& .MuiSvgIcon-root": {
                                    color: "#0073C7",
                                },
                                "& #demo-simple-select": {
                                    paddingBottom: "15px",
                                    paddingTop: "15px",
                                },
                                border: "red",
                            }}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={companyCode}
                            onChange={handleChangeCompany}
                            displayEmpty
                        >
                            {companyList.map((item) => (
                                <MenuItem value={item.code}>
                                    {getNameInCapitalize(item.name)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <input
                        type="text"
                        placeholder="Tìm kiếm"
                        className="bg-[#F8F8F8] mt-3 px-5 py-4 rounded-xl w-full  focus-visible:outline-none"
                        // onChange={(e) => {
                        //     setSearchString(e.target.value);
                        // }}
                        // value={searchString}
                        // onSubmit={handleQuickSearch}
                        // onBlur={handleQuickSearch}
                        // onKeyPress={(e) => {
                        //     if (e.key === "Enter") {
                        //         handleQuickSearch();
                        //     }
                        // }}
                    />
                </List>
            </div>
            <footer className="sticky bottom-0 bg-white px-5 py-[15px] shadow-[0px_0px_8px_rgba(0,0,0,0.25)] flex gap-3 items-center">
                <button
                    onClick={() => {}}
                    className="text-center text-[red] rounded bg-ItemBg  py-[9px] w-full"
                >
                    <div className="font-semibold text-[14px] leading-[22px]">
                        Hủy chọn
                    </div>
                </button>
                <button
                    onClick={() => {}}
                    className="text-center text-white rounded bg-primary  py-[9px] w-full"
                >
                    <div className="font-semibold  text-[14px] leading-[22px]">
                        Đồng ý
                    </div>
                </button>
                {/* <ShareIos onClick={handelShare} /> */}
            </footer>
        </Dialog>
    );
};

export default inject("companyStore")(observer(SelecteUserDialog));
